import React, { useEffect, useRef, useState } from "react";

const Report = ({ content }) => {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState(600);
  const resizeTimeoutRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const resizeIframe = () => {
      clearTimeout(resizeTimeoutRef.current);
      resizeTimeoutRef.current = setTimeout(() => {
        if (iframe.contentWindow?.document?.body) {
          const newHeight = iframe.contentWindow.document.body.scrollHeight;
          setIframeHeight(newHeight);
        }
      }, 1000);
    };

    const injectStylesToIframe = () => {
      const doc = iframe?.contentDocument;
      if (!doc) return;
      doc.body.style.overflow = "hidden";
      document.querySelectorAll("link[rel='stylesheet'], style").forEach((style) => {
        const clone = style.cloneNode(true);
        doc.head.appendChild(clone);
      });
    };

    const observeIframeChanges = () => {
      if (!iframe.contentDocument?.body) return;
      const observer = new MutationObserver(() => {
        resizeIframe();
      });
      observer.observe(iframe.contentDocument.body, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    };

    const handleLoad = () => {
      resizeIframe();
      injectStylesToIframe();
      observeIframeChanges();
    };

    iframe.addEventListener("load", handleLoad);

    return () => {
      iframe.removeEventListener("load", handleLoad);
      clearTimeout(resizeTimeoutRef.current);
    };
  }, []);

  return (
    <div style={{ textAlign: "center", width: "100%", background: "transparent" }}>
      <iframe
        ref={iframeRef}
        style={{ width: "100%", height: `${iframeHeight}px`, border: "none" }}
        srcDoc={content}
        sandbox="allow-same-origin"
      />
    </div>
  );
};

export default Report;
